import { render, staticRenderFns } from "./Terms&Policy.vue?vue&type=template&id=0dd0ec04&"
import script from "./Terms&Policy.vue?vue&type=script&lang=js&"
export * from "./Terms&Policy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports